module.exports = __webpack_public_path__ + "img/top_ui.c21818ee.png";